import { GridPostParams, GridModel } from "common/models/utility-models/list-utility.model";
import { FeedbackStudentModel } from "./feedback-student-data.model";

export class FeedbackStudentGridModel extends FeedbackStudentModel {}
export class FeedbackStudentGridParams extends GridPostParams {
    feedback_form_mapping_id: any = '';
}


export class FeedbackStudentListingModel extends GridModel<FeedbackStudentGridModel> {}
